import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";
import {RequestMethod, Response} from "@angular/http";
import {RequestConfig, RestResponse} from "../../shared/rest/rest.request";
import {CustomHttp} from "../../common/http/custom.http";
import {PageImpl} from "../../common/http/PageImpl";
import { NzI18nService ,es_ES} from "ng-zorro-antd";

@Injectable()
export class ProfilesService {
    private CREATE_CODE = new RequestConfig("PRF", "application/json", true, RequestMethod.Post, "/profiles");
    private EDIT_CODE = new RequestConfig("PRF", "application/json", true, RequestMethod.Put, "/profiles/{profileId}");
    private DELETE_CODE = new RequestConfig("PRF", "application/json", true, RequestMethod.Delete, "/profiles/{profileId}");
    public GET_CODE = new RequestConfig("PRF", "application/json", true, RequestMethod.Get, "/profiles/{profileId}");
    public GET_ALL_CODE = new RequestConfig("PRF", "application/json", true, RequestMethod.Get, "/profiles/all");
    public GET_PAGE = new RequestConfig("PRF", "application/json", true, RequestMethod.Get, "/profiles");
    private GET_TREE_CODE = new RequestConfig("PRF", "application/json", true, RequestMethod.Get, "/profiles/tree");

    constructor(private http: CustomHttp,
        private i18n: NzI18nService) {
            this.i18n.setLocale(es_ES);
    }

    /**
     * Envia una petición a WS para guardar perfil
     */
    save(profile: Profile): Observable<RestResponse> {
        return this.http.sendRequest(this.CREATE_CODE, profile)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición a WS para obtener detalles de un perfil
     */
    get(profileId: number): Observable<Profile> {
        return this.http.sendRequest(this.GET_CODE, {}, profileId)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición a WS para obtener detalles de los perfiles
     */
    getAll(): Observable<Array<Profile>> {
        let allProfiles: any = localStorage.getItem('allProfiles');
        if (allProfiles != undefined || allProfiles != null) {
            let allProfilesParse = JSON.parse(allProfiles)
            if (allProfilesParse != undefined) {
                let newData = new BehaviorSubject<any>(null);
                newData.next(allProfilesParse)
                return newData;
            }
        }
        else {
            return this.http.sendRequest(this.GET_ALL_CODE)
                .map((res: any) => {
                    try {
                        localStorage.setItem('allProfiles', res._body);
                        return res.json();
                    } catch (e) {
                        return e => this.http.handleError(e);
                    }
                })
        };
    }

    /**
     * Envia petición a WS para obtener el arbol de permisos general
     */
    getTree(): Observable<Array<RestResponse>> {
        return this.http.sendRequest(this.GET_TREE_CODE)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envía petición a WS para editar datos de perfil
     */
    update(profile: Profile): Observable<RestResponse> {
        return this.http.sendRequest(this.EDIT_CODE, profile, profile.profileId)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición al servidor para eliminar el perfil
     */
    delete(profileId: number) {
        return this.http.sendRequest(this.DELETE_CODE, {}, profileId)
            .catch(error => this.http.handleError(error));
    }

    getPage(options: any): Observable<PageImpl<Profile>> {
        return this.http.sendRequest(this.GET_PAGE, options)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }
}

@Injectable()
export class Profile {
    public profileId: number;
    public profileName: string;
    public profilePermissions: Array<ProfilePermission> = [];
    public tree: Array<Branch> = [];
    public idTypeTicket?: number;
}

@Injectable()
export class ProfilePermission {
    public permissionId: number;
}

@Injectable()
export class Branch {
    private id: number;
    private content: string;
    private children: Array<Branch>;
    private active: boolean;
    private module: boolean;
    private expanded: boolean;
}


export class ProfileAdvanceSearch {
    active: boolean;
    name: string;
    page: number;
    size: number;
    orderColumn: string;
    orderType: string;
}
